import profileImage from '../assets/DSC_2130-demo.png';
import resumePDF from '../assets/SABARISAN.pdf';

const AboutMe = () => {
  const handleDownloadCV = () => {
    const link = document.createElement('a');
    link.href = resumePDF;
    link.download = 'Sabarisan_P_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="bg-gradient-to-b from-[#0e0e2c] via-[#2d1b3d] to-[#1f1f1f] text-white py-16 px-6 border-b-4 border-pink-500/30">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
        {/* Profile Image */}
        <div className="flex justify-center md:justify-start">
          <div className="relative w-40 h-40 rounded-full border-4 border-pink-500 overflow-hidden shadow-2xl shadow-pink-500/50">
            <img
              src={profileImage}
              alt="Profile"
              className="w-full object-cover"
            />
          </div>
        </div>

        {/* About Text */}
        <div className="md:col-span-2">
          <h2 className="text-2xl md:text-2xl font-bold mb-2 inline-block 
                border-b-4 border-transparent hover:border-pink-600 
                pb-1 transition-colors duration-300">
            About Me
          </h2>
          <p className="text-gray-300 text-sm mb-6 italic leading-relaxed">
            I am <span className="font-semibold text-pink-400">Sabarisan P</span>, a passionate Front End Developer with 3 years of experience in logistics and supply chain operations. Currently working as a PHP Full Stack Developer Trainee at Ezeeinfo cloud solutions. I specialize in PHP development, RESTful API integration, database management, and creating dynamic dashboards for improved transparency and operations.
          </p>
          <button 
            onClick={handleDownloadCV}
            className="bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white px-6 py-2 rounded-lg transition-all font-medium shadow-lg shadow-pink-500/30 transform hover:scale-105"
          >
            Download CV
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;